export default "__VITE_ASSET__DOvhj0bh__"